export default __webpack_public_path__ + "static/media/acneActive.542888a5.svg";